<template>
    <div class="eos__form">
        <div class="eos__form--title">
            <h2>{{ title }}</h2>
        </div>
        <div class="eos__form--content">
            <el-form ref="form" :model="eosForm" :rules="rules" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="eos__form--content--item">
                            <label>Start Date</label>
                            <el-form-item prop="startDate">
                                <el-date-picker 
                                    format="yyyy-MM-dd" 
                                    value-format="yyyy-MM-dd" 
                                    v-model="eosForm.from" 
                                    type="date" 
                                    placeholder="Select Date"
                                    :picker-options="{
                                        disabledDate(time) {
                                            return time.getTime() <= Date.now()
                                        }
                                    }">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <hr>
                    </el-col>
                    <el-col :span="24">
                        <div class="eos__form--content--header">
                            <h3>Shifts</h3>
                            <button class="eos__form--content--header--btn" @click.prevent="$emit('add-shift')">Add Shift</button>
                        </div>
                        <el-collapse v-if="eosForm.shifts.length > 0" class="eos__form--content__shifts" v-model="activeSequences" accordion>
                            <el-collapse-item class="eos__form--content__shifts--item" v-for="(shift, i) in eosForm.shifts" :key="`shift-${i}`" :name="`sequence-${i + 1}`">
                                <template slot="title">
                                    <span>Sequence {{i + 1}}</span>
                                    <el-button type="text" icon="el-icon-delete" circle class="eos__form--content__shifts--item--delete" size="medium" @click.stop="$emit('remove-shift', i)" style="margin-left: 10px;"></el-button>
                                </template>
                                <el-row :gutter="20" type="flex" justify="center" align="middle">
                                    <el-col :span="12">
                                        <div class="eos__form--content--item">
                                            <label>Shift Name</label>
                                            <el-input v-model="shift.name" placeholder="Enter Shift Name"></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="eos__form--content--item">
                                            <label>Start Time</label>
                                            <el-time-select v-model="shift.startTime" placeholder="Select Time" :picker-options="{ start: '00:00', step: '00:15', end: '24:00' }"></el-time-select>
                                        </div>
                                    </el-col>
                                </el-row>
                                <div class="eos__form--content--services__header">
                                    <h3>Services</h3>
                                    <button class="eos__form--content--header--btn" @click.prevent="$emit('add-service', i)">Add Service</button>
                                </div>
                                <el-collapse v-if="shift.services.length > 0" class="eos__form--content__shifts--services" v-model="activeServices" accordion>
                                    <el-collapse-item class="eos__form--content--services--item" v-for="(service, j) in shift.services" :key="`service-${j}`" :title="`Service ${j + 1}`" :name="`service-${j + 1}`">
                                        <template slot="title">
                                            <span>{{ service.name ? service.name : `Service ${j + 1}` }}</span>
                                            <el-button type="text" icon="el-icon-delete" circle class="eos__form--content__shifts--item--delete" size="medium" @click.stop="$emit('remove-service', { shiftIndex: i, serviceIndex: j })" style="margin-left: 10px;"></el-button>
                                        </template>
                                        <el-row :gutter="20" type="flex" justify="center" align="middle">
                                            <el-col :span="12">
                                                <div class="eos__form--content--item">
                                                    <label>Service Name</label>
                                                    <el-input v-model="service.name" placeholder="Enter Service Name"></el-input>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="eos__form--content--item">
                                                    <label>Start Time</label>
                                                    <el-time-select v-model="service.startTime" placeholder="Select Time" :picker-options="{ start: '00:00', step: '00:15', end: '24:00' }"></el-time-select>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="24">
                                                <div class="eos__form--content--item">
                                                    <label class="mb-4">Days of Week</label>
                                                    <el-checkbox-group v-model="service.daysOfWeek">
                                                        <el-checkbox v-for="day in daysOfWeekList" :key="day" :label="day"></el-checkbox>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </el-collapse>
                                <div v-else class="eos__form--content--shifts--item--services--empty">
                                    <p class="text-center">No Services</p>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                        <div v-else class="eos__form--content--shifts--empty">
                            <p class="text-center">No Shifts</p>
                        </div>
                    </el-col>
                </el-row>
                <div class="eos__form--content--footer">
                    <button :disabled="loading" class="eos__form--content--footer--btn__cancel" @click="$emit('cancel')">Cancel</button>
                    <button v-if="!editEosVenueId" :disabled="loading" class="eos__form--content--footer--btn__confirm" @click="handleConfirm">
                        <i v-if="loading" class="el-icon-loading"></i>
                        Confirm
                    </button>
                    <button v-else :disabled="loading" class="eos__form--content--footer--btn__confirm" @click="handleEditConfirm">
                        <i v-if="loading" class="el-icon-loading"></i>
                        Confirm
                    </button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        eosForm: Object,
        rules: Object,
        venues: Array,
        daysOfWeekList: Array,
        loading: Boolean,
        title: String,
        editEosVenueId: [String, Number],
        activeSequences: Array,
        activeServices: Array
    },
    methods: {
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.eosForm.shifts.length === 0) {
                    this.$message.error('Please add at least one shift');
                    return;
                }
                for (let i = 0; i < this.eosForm.shifts.length; i++) {
                    const shift = this.eosForm.shifts[i];
                    if (!shift.name) {
                        this.$message.error(`Please enter a name for Sequence ${i + 1}`);
                        return;
                    }
                    if (!shift.startTime) {
                        this.$message.error(`Please select a start time for Sequence ${i + 1}`);
                        return;
                    }
                    if (shift.services.length === 0) {
                        this.$message.error(`Please add at least one service for Sequence ${i + 1}`);
                        return;
                    }
                    for (let j = 0; j < shift.services.length; j++) {
                        const service = shift.services[j];
                        if (!service.name) {
                            this.$message.error(`Please enter a name for Service ${j + 1} in Sequence ${i + 1}`);
                            return;
                        }
                        if (!service.startTime) {
                            this.$message.error(`Please select a start time for ${service.name || `Service ${j + 1}`} in Sequence ${i + 1}`);
                            return;
                        }
                        if (service.daysOfWeek.length === 0) {
                            this.$message.error(`Please select at least one day for ${service.name || `Service ${j + 1}`} in Sequence ${i + 1}`);
                            return;
                        }
                    }
                }
                this.$emit('submit', JSON.parse(JSON.stringify(this.eosForm)));
            });
        },
        handleEditConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.eosForm.shifts.length === 0) {
                    this.$message.error('Please add at least one shift');
                    return;
                }
                for (let i = 0; i < this.eosForm.shifts.length; i++) {
                    const shift = this.eosForm.shifts[i];
                    if (!shift.name) {
                        this.$message.error(`Please enter a name for Sequence ${i + 1}`);
                        return;
                    }
                    if (!shift.startTime) {
                        this.$message.error(`Please select a start time for Sequence ${i + 1}`);
                        return;
                    }
                    if (shift.services.length === 0) {
                        this.$message.error(`Please add at least one service for Sequence ${i + 1}`);
                        return;
                    }
                    for (let j = 0; j < shift.services.length; j++) {
                        const service = shift.services[j];
                        if (!service.name) {
                            this.$message.error(`Please enter a name for Service ${j + 1} in Sequence ${i + 1}`);
                            return;
                        }
                        if (!service.startTime) {
                            this.$message.error(`Please select a start time for ${service.name || `Service ${j + 1}`} in Sequence ${i + 1}`);
                            return;
                        }
                        if (service.daysOfWeek.length === 0) {
                            this.$message.error(`Please select at least one day for ${service.name || `Service ${j + 1}`} in Sequence ${i + 1}`);
                            return;
                        }
                    }
                }
                this.$emit('submit', JSON.parse(JSON.stringify(this.eosForm)));
            });
        }
    }
}
</script> 


// WEBPACK FOOTER //
// src/components/eos/components/EosForm.vue